/* eslint-disable array-callback-return */
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactHtmlTableToExcel from "react-html-table-to-excel";

import Card from "../../../component/card/Card";
import QueryList from "./QueryList";
import Starter from "../../../component/Starter";
import TopInput from "./TopInput";
import { helperFunction } from "../../../constant/helper";
import useSortableData from "../../../customHooks/sortingHooks";
import TableHeader from "../../../component/tableHeader/TableHeader";
import { tableHeaderData } from "./queryStaticData";
import isEmpty from "../../../validation/isEmpty";
import {
  filterQuery,
  tableSkeleton
} from "../../../constant/helper/helper";
import {
  getAllQueries,
  setQueryLoading,
  clearQueryErrors,
  clearQueryResult
} from "../../../redux/actions/queryActions";

const initialState = {
  Filter: "",
  date: "date",
  dataTypes: "",
  locationId: "locationId"
};

const AllQuery = () => {
  const loginType = localStorage.loginType;
  const dispatch = useDispatch();
  const [allQueries, setAllQueries] = useState([]);
  const [values, setValues] = useState(initialState);
  const [allLocations, setAllLocations] = useState([]);

  const { currentUser } = useSelector((state) => state.auth);
  const {
    queries,
    queryDate,
    queryError,
    queryLoading,
    queryLocation,
    queryDataTypes
  } = useSelector((state) => state.query);
  const { locations } = useSelector((state) => state.location);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value
    });
  };

  useEffect(() => {
    if (locations !== null) {
      setAllLocations(locations);
    } else {
      setAllLocations([]);
    }
  }, [locations]);

  useEffect(() => {
    setValues({
      ...values,
      date: queryDate,
      locationId: queryLocation,
      dataTypes: queryDataTypes
    });
  }, [queryDate, queryLocation, queryDataTypes]);

  useEffect(() => {
    return () => {
      dispatch(setQueryLoading(false));
      dispatch(clearQueryErrors());
      dispatch(clearQueryResult());
    };
  }, []);

  useEffect(() => {
    if (!isEmpty(queries)) {
      setAllQueries(queries);
    } else {
      setAllQueries([]);
    }
  }, [queries]);

  useEffect(() => {
    if (queryError) {
      helperFunction.toastHelper("error", queryError);
    }
  }, [queryError]);

  const fetchQueryFromDate = (e) => {
    e.preventDefault();
    dispatch(setQueryLoading(true));
    dispatch(clearQueryErrors());
    dispatch(clearQueryResult());

    dispatch(
      getAllQueries(
        values.dataTypes,
        values.date,
        values.locationId,
        loginType
      )
    );
  };

  const { items, requestSort, sortConfig } = useSortableData(
    allQueries
  );

  const showQueryList = (queryListArray) => {
    const sortedQueryArray = filterQuery(
      values.Filter,
      queryListArray
    );

    if (queryLoading) {
      return <tr>{tableSkeleton(10)}</tr>;
    } else if (sortedQueryArray === null) {
      return (
        <tr style={{ top: "50%", left: "50%", position: "fixed" }}>
          <td>
            <span className="">
              Please Select Different Date and Locations
            </span>
          </td>
        </tr>
      );
    } else if (sortedQueryArray.length === 0) {
      return (
        <tr style={{ top: "50%", left: "50%", position: "fixed" }}>
          <td>
            <span className="">
              No Record Found for date {values.date}
            </span>
          </td>
        </tr>
      );
    } else if (
      !isEmpty(sortedQueryArray) &&
      sortedQueryArray.length > 0
    ) {
      return sortedQueryArray.map((queryItem, queryListIndex) => (
        <QueryList
          key={queryListIndex}
          querySearchResult={queryItem}
          queryListIndex={queryListIndex}
        />
      ));
    }
  };
  return (
    <Starter
      topBarTitle="All Queries"
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">Query Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">Query</a>
          </li>
          <li className="breadcrumb-item active">All Queries</li>
        </Fragment>
      }
    >
      <Card>
        <TopInput
          values={values}
          loading={queryLoading}
          currentUser={currentUser}
          onChange={handleInputChange}
          onSubmit={fetchQueryFromDate}
          allLocations={
            typeof allLocations !== "undefined" &&
            allLocations.length > 0
              ? allLocations
              : []
          }
        />
        <div
          className="table-responsive"
          style={{
            height: "700px",
            overflow: "auto"
          }}
        >
          <table
            className="table table-bordered table-centered mb-0 table-hover w-100 dt-responsive nowrap"
            id="products-datatable"
          >
            <thead className="thead-light">
              <tr>
                <th style={{ width: "20px" }}>Query Id</th>
                <th>Date</th>
                <TableHeader
                  tableHeaderData={tableHeaderData}
                  requestSort={requestSort}
                  sortConfig={sortConfig}
                />
                <th>Title</th>
                <th>Query</th>
                <th>Platform</th>
                <th>Attachment</th>
                <th className="text-center">Actions</th>
              </tr>
            </thead>
            <tbody>{showQueryList(items)}</tbody>
          </table>
        </div>
        <div className="col-lg-2 col-md-2 mt-3">
          <ReactHtmlTableToExcel
            sheet="Sheet"
            buttonText="Export excel"
            table="products-datatable"
            className="btn btn-dark btn-block"
            filename={`${values.date}_${values.locationId}`}
          />
        </div>
      </Card>
    </Starter>
  );
};

export default AllQuery;
